/**
 * Per-character counts, applied.
 *
 * The library's rows carry "how many of this one". Load expanded them
 * inline; → Waiting did not, so the count silently applied to one of
 * the two buttons that show it (v8.34.0). Both call this now.
 *
 * A count is a number typed into an input, so it is clamped rather than
 * trusted: anything below one means one.
 */
function timesFor(counts: Record<string, number>, id: string): number {
  return Math.max(1, Math.floor(counts[id] ?? 1));
}

/** Each item repeated as many times as its count asks, in list order. */
export function expandByCount<T extends { id: string }>(items: readonly T[], counts: Record<string, number>): T[] {
  return items.flatMap((item) => Array.from({ length: timesFor(counts, item.id) }, () => item));
}

/** How many bodies `expandByCount` would produce - for a button's label. */
export function totalByCount<T extends { id: string }>(items: readonly T[], counts: Record<string, number>): number {
  return items.reduce((n, item) => n + timesFor(counts, item.id), 0);
}

/**
 * The inverse, for whoever wants the CHARACTERS rather than the bodies.
 *
 * Three of somebody are three combatants and one library entry, so the
 * library write has to be given the set rather than the list. First
 * occurrence wins, so list order is preserved.
 */
export function uniqueById<T extends { id: string }>(items: readonly T[]): T[] {
  const seen = new Set<string>();
  return items.filter((item) => {
    if (seen.has(item.id)) return false;
    seen.add(item.id);
    return true;
  });
}
